export default {"id":"icon-loader"}